import { LOCATION_CHANGE } from 'react-router-redux'

export const breadcrumbRecuder = (
  state = {
    paths: []
  },
  action
) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      let newPath
      let mustSwitch = true
      const url = action.payload.location.pathname

      let sameIndex
      let checkoutFromHome = true
      state.paths.map((path, index) => {
        // Verifica se a url ja foi acessada
        if (path.url === url) {
          sameIndex = index
          state.paths[index].current = true
        } else {
          state.paths[index].current = false
        }

        // Verifica se o checkout está sendo acessado via home
        if (path.url.split('/')[1] === 'cart') {
          checkoutFromHome = false
        }

        // Trata a voltagem do produto para não duplicar
        if (url.split('/')[1] === 'products' && path.url.split('/')[1] === 'products') {
          state.paths[index].url = url
          state.paths[index].current = true
          mustSwitch = false
        }
      })

      if (mustSwitch) {
        switch (url.split('/')[1]) {
          case 'products':
            newPath = { url, description: 'Detalhes do produto', reset: false }
            break
          case 'search':
            newPath = { url, description: 'Busca', reset: true }
            break
          case 'checkout':
            if (url.split('/')[2] && url.split('/')[2] === 'points-purchase') {
              newPath = { url, description: 'Comprar pontos', reset: true }
            } else {
              newPath = { url, description: 'Resumo do pedido', reset: checkoutFromHome }
            }
            break
          case 'cart':
            newPath = { url, description: 'Carrinho', reset: true }
            break
          case 'mileage':
            newPath = { url, description: 'Milhas', reset: true }
            break
          case 'categories':
            newPath = { url, description: 'Categorias', reset: true }
            break
          case 'my-orders':
            newPath = { url, description: 'Pedidos', reset: true }
            break
          case 'pointsandcash':
            newPath = { url, description: 'Pontos + dinheiro', reset: true }
            break
          case 'services':
            if (url.split('/')[2]) {
              newPath = { url, description: 'Resumo do serviço', reset: true }
            }
            break
          case 'billpayment':
            newPath = { url, description: 'Pagamento de contas', reset: true }
            break
          case 'my-address':
            newPath = { url, description: 'Endereço', reset: true }
            break
          case 'mobile-recharge':
            if (url.split('/')[2]) {
              newPath = { url, description: 'Resumo da recarga', reset: true }
            } else {
              newPath = { url, description: 'Recarga de celular', reset: true }
            }
            break
          case 'confirmation-donation':
            newPath = { url, description: 'Resumo da doação', reset: true }
            break
          case 'terms':
            newPath = { url, description: 'Termos de uso', reset: true }
            break
          case 'regulation':
            newPath = { url, description: 'Regulamento', reset: true }
            break
          case 'accessibility-status':
            newPath = { url, description: 'Estatuto de acessibilidade', reset: true }
            break
          case 'benefits':
            newPath = { url, description: 'Benefícios', reset: true }
            break
          case 'points-purchase':
            newPath = { url, description: 'Compra de pontos', reset: true }
            break
          case 'security':
            newPath = { url, description: 'Segurança', reset: true }
            break
          case 'privacy':
            newPath = { url, description: 'Política de privacidade', reset: true }
            break
          case 'profile':
            newPath = { url, description: 'Informações pessoais', reset: true }
            break
          case 'extract':
            newPath = { url, description: 'Extrato', reset: true }
            break
          case 'fuelcredit':
            newPath = { url, description: 'Resgate de combustível', reset: true }
            break
          case 'donation':
            newPath = { url, description: 'Doação', reset: true }
            break
          case 'stix':
            newPath = { url, description: 'Stix', reset: true }
            break
          case 'showcase':
            newPath = { url, description: 'Busca', reset: true }
            break
          case 'vendor':
            newPath = { url, description: 'Busca', reset: true }
            break
          case 'wishlist':
            newPath = { url, description: 'Favoritos', reset: true }
            break
          case 'two-step-verification':
            newPath = { url, description: 'Verificação em duas etapas', reset: true }
            break
          case 'faq-two-step':
            newPath = { url, description: 'FAQ verificação em duas etapas', reset: true }
            break
          case 'scheduling':
            newPath = { url, description: 'Resgates recorrentes', reset: true }
            break
          case 'orders':
            newPath = { url, description: 'Pedidos', reset: true }
            break
          case 'order':
            if (url.split('/')[4] && url.split('/')[4] === 'product') {
              newPath = { url, description: 'Detalhes do pedido', reset: false }
            } else {
              newPath = { url, description: 'Pedido', reset: true }
            }
            break
          case 'my-account':
            newPath = { url, description: 'Alteração de senha', reset: true }
            break
          case 'security-access':
            newPath = { url, description: 'Acesso e segurança', reset: true }
            break
          case 'stores':
            if (url.split('/')[2]) {
              newPath = { url, description: 'Vouchers', reset: false }
            } else {
              newPath = { url, description: 'Lojas', reset: true }
            }
            break
          case 'auth':
            newPath = false
            break
          default:
            newPath = null
            break
        }
      } else {
        return { ...state }
      }

      // Home e auth
      if (newPath === null) {
        return {
          ...state,
          paths: []
        }
        // @ts-ignore
      } else if (newPath === false || newPath === undefined) {
        return { ...state }
      }

      // @ts-ignore
      newPath.current = true

      // @ts-ignore
      if (newPath.reset) {
        return {
          ...state,
          paths: [newPath]
        }
      } else {
        if (sameIndex !== undefined) {
          return {
            ...state,
            paths: [...state.paths.slice(0, (Number(sameIndex) + 1))]
          }
        }

        return {
          ...state,
          paths: [...state.paths, newPath]
        }
      }
    case 'FILTER_CHANGE_LOCATION':
      const filterURL = action.payload.params.url

      if (filterURL.includes('/search')) {
        const searchURL = action.payload.params.url.split('/search??')
        if (searchURL[1]) {
          const newSearch = { url: '/search?' + searchURL[1], description: 'Busca', reset: true, current: true }
          return { paths: [newSearch] }
        } else {
          return { ...state }
        }
      } else if (filterURL.includes('/vendor')) {
        const vendorURL = action.payload.params.url.split('/vendor??')
        if (vendorURL[1]) {
          const newSearch = { url: '/vendor?' + vendorURL[1], description: 'Busca', reset: true, current: true }
          return { paths: [newSearch] }
        } else {
          return { ...state }
        }
      } else if (filterURL.includes('/showcase')) {
        const showcaseURL = action.payload.params.url.split('/showcase??')
        if (showcaseURL[1]) {
          const newSearch = { url: '/showcase?' + showcaseURL[1], description: 'Busca', reset: true, current: true }
          return { paths: [newSearch] }
        } else {
          return { ...state }
        }
      }

      return { ...state }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/App/Breadcrumb/reducer.js